class ProductEngraving extends HTMLElement {
  constructor () {
    super()

    this.trigger = window.BAO.utils.getElement('.prd-Engraving_Trigger')
    this.form = window.BAO.utils.getElement('.prd-Engraving_Form')
    this.input = window.BAO.utils.getElement('.prd-Engraving_Input')
    this.productForm = window.BAO.utils.getElement('.js-Product_Form')
    this.container = window.BAO.utils.getElement('.prd-Engraving')
    this.list = window.BAO.utils.getElement('.prd-Engraving_Items')
    this.charCount = window.BAO.utils.getElement('.prd-Engraving_CharCount')

    this.trigger.addEventListener('click', this.onTriggerClick.bind(this))
    this.input.addEventListener('input', this.onInputType.bind(this))
  }

  onTriggerClick () {
    this.form.setAttribute(
      'aria-hidden',
      this.form.getAttribute('aria-hidden') === 'true' ? 'false' : 'true'
    )
    this.trigger.classList.toggle('prd-Engraving_Trigger-active')
  }

  onInputType = ({ target }) => {
    this.charCount.innerHTML = 10 - target.value.length

    this.list.innerHTML = ''
    if (target.value) {
      target.classList.add('prd-Engraving_Initial-hasValue')

      this.createHiddenInput('Engraving', target.value, this.list)

      if (this.container.dataset.engravingId) {
        this.productForm.setAttribute(
          'data-form-engraving-id',
          this.container.dataset.engravingId
        )
      }

      this.container.classList.add('prd-Engraving-selected')
    } else {
      target.classList.remove('prd-Engraving_Initial-hasValue')

      this.productForm.removeAttribute('data-form-engraving-id')

      this.container.classList.remove('prd-Engraving-selected')
    }
  }

  createHiddenInput (name, value, container) {
    const input = window.BAO.utils.createElement('input', {
      name: `properties[${name}]`,
      value,
      type: 'hidden',
    })
    container.appendChild(input)
  }
}

customElements.define('product-engraving', ProductEngraving)
